import { BackgroundImageFillMode } from "../types/canvasTypes";
import { ExtendedObject } from "../types/objectTypes";

export function returnBackgroundColorOrDefault(fill?: ExtendedObject["fill"]) {
  return (fill as string) ?? "#ffffff";
}

export function returnBackgroundImageOpacityOrDefault(opacity?: number) {
  return opacity ?? 1;
}

export function returnImageUrlOrDefault(url?: string) {
  return url ?? null;
}

export function returnImageFillModeOrDefault(fillMode?: BackgroundImageFillMode): BackgroundImageFillMode {
  return fillMode ?? "cover";
}
